// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image-content[data-v-4bb53172]{width:min(350px,100%);height:350px}.text-content[data-v-4bb53172]{max-width:600px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
